export const globalVars = {
  noImageFileNameSmall: 'no-image-100x100.jpg',
  noImageFileNameLarge: 'no-image-350x350.jpg'
}



// WEBPACK FOOTER //
// ./src/globalVars.js